import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Metadata } from 'ui/acro/typography'
import { useModal_deprecated, useGetCountry } from 'hooks'

import PrivacyModal from './PrivacyModal'
import TermsModal from './TermsModal'
import CustomTermsModal from './CustomTermsModal'

import { builder } from '@builder.io/sdk'

import {
  TERMS_OF_SERVICE_URL,
  PRIVACY_POLICY_URL
} from 'components_v1/SchemaSectionRenderer/common/components/constants'

const ModalPopup = styled('span')({
  cursor: 'pointer',
  fontWeight: 'bold',
  textDecoration: 'underline',
  color: '#00E'
})

const ModalLink = styled('a')({
  cursor: 'pointer',
  fontWeight: 'bold',
  textDecoration: 'underline',
  color: '#00E',
  '&:hover, &:active, &:visited, &:focus': {
    color: '#00E',
    textDecoration: 'underline'
  }
})

const Disclaimer = ({
  actionText,
  Wrapper,
  reactivate = false,
  isSignupScreen = true,
  hideSignInDisclimer = false,
  passcodeAvailable = false,
  aloWellnessTerm = false,
  passcodeLabel = '',
  ...rest
}) => {
  const terms = useModal_deprecated()
  const privacy = useModal_deprecated()
  const partnerTerms = useModal_deprecated()
  const country = useGetCountry()

  const [partnerName, setPartnerName] = useState('')
  const [termsContent, setTermsContent] = useState('')
  const [partnerTermsAvailable, setPartnerTermsAvailable] = useState(false)

  useEffect(() => {
    const builderPublicApiKey =
      window?.REACT_ENV_VARIABLES?.BUILDER_PUBLIC_API_KEY ||
      '61e2402350ce4c0cbc02c5526b936de4'

    // Initialize builder.io with the appropriate key
    builder.init(builderPublicApiKey)

    const fetchPartnerTerms = async () => {
      try {
        const response = await builder.get('partner-terms-conditions', {
          userAttributes: { urlPath: window.location.pathname }
        })

        if (response && response.data) {
          const termsData = response.data
          setPartnerName(termsData.partnerName || '')
          setTermsContent(termsData.terms || '')
          setPartnerTermsAvailable(true)
        } else {
          setPartnerTermsAvailable(false)
        }
      } catch (error) {
        console.error('Error fetching partner terms:', error)
        setPartnerTermsAvailable(false)
      }
    }

    fetchPartnerTerms()
  }, [])

  return (
    <Fragment>
      <Wrapper {...rest}>
        <div style={{ lineHeight: '18px' }}>
          {' '}
          By clicking &quot;{actionText}&quot;
          {!reactivate && !hideSignInDisclimer && (
            <>
              {' or using one of the '}
              {isSignupScreen ? 'sign up' : 'sign in'} methods below,
            </>
          )}{' '}
          {passcodeAvailable && (
            <>{' or “' + `${passcodeLabel}` + ' with One-Time Passcode” '}</>
          )}{' '}
          you agree to
          {partnerTermsAvailable ? ' ALO Wellness Club ' : '  ALO’s '}
          <ModalLink
            id='terms'
            onClick={(e) => e.currentTarget.blur()}
            href={TERMS_OF_SERVICE_URL}
            target='_blank'
          >
            Terms of Service
          </ModalLink>
          {aloWellnessTerm && (
            <>
              {` and ALO Wellness Club's`}
              <ModalPopup onClick={terms.open} id='aloWellTerms'>
                {' '}
                Terms of Service{' '}
              </ModalPopup>{' '}
            </>
          )}
          {partnerTermsAvailable ? ', ' : ' and acknowledge our '}
          <ModalLink
            id='privacy_policy'
            onClick={(e) => e.currentTarget.blur()}
            href={PRIVACY_POLICY_URL}
            target='_blank'
          >
            Privacy Policy
          </ModalLink>
          {partnerTermsAvailable && (
            <>
              {' and '}
              {partnerName}{' '}
              <ModalLink onClick={partnerTerms.open} id='partner_terms'>
                Terms & Conditions
              </ModalLink>
            </>
          )}
          {'.'}
        </div>
      </Wrapper>

      {terms.active && <TermsModal useModal={terms} country={country} />}
      {partnerTerms.active && (
        <CustomTermsModal
          useModal={partnerTerms}
          termsContent={termsContent}
          customHeader={partnerName + ' Terms & Conditions'}
        />
      )}
      {privacy.active && <PrivacyModal useModal={privacy} />}
    </Fragment>
  )
}

Disclaimer.defaultProps = {
  Wrapper: Metadata
}

Disclaimer.propTypes = {
  actionText: PropTypes.string.isRequired,
  Wrapper: PropTypes.any,
  country: PropTypes.string.isRequired
}

export default Disclaimer
